import { Module } from 'vuex';
import { RootState, TableState } from '../types';
import cloneDeep from 'lodash/cloneDeep';

export const SET_TABLE_OPTIONS = 'SET_TABLE_OPTIONS';
const SHOW_EXPORT_LOADING = 'SHOW_EXPORT_LOADING';
const HIDE_EXPORT_LOADING = 'HIDE_EXPORT_LOADING';
const RESET_STATE = 'RESET_STATE';

export const TableGetterKeys = {
	exportLoading: 'exportLoading',
	tableOptions: 'tableOptions',
};

export const TableActionKeys = {
	showExportLoading: 'showExportLoading',
	hideExportLoading: 'hideExportLoading',
	resetState: 'resetState',
};

const initialState: TableState = {
	exportLoading: false,
	tableOptions: {},
};

const store: Module<TableState, RootState> = {
	namespaced: true,

	state: cloneDeep(initialState),

	actions: {
		async [TableActionKeys.resetState]({ commit }) {
			commit(RESET_STATE);
		},

		async [TableActionKeys.showExportLoading]({ commit }) {
			commit(SHOW_EXPORT_LOADING);
		},

		async [TableActionKeys.hideExportLoading]({ commit }) {
			commit(HIDE_EXPORT_LOADING);
		},
	},

	mutations: {
		[RESET_STATE](state) {
			Object.assign(state, cloneDeep(initialState));
		},

		[SET_TABLE_OPTIONS](state, tableOptions) {
			state.tableOptions[tableOptions.key] = tableOptions.options;
		},

		[SHOW_EXPORT_LOADING](state) {
			state.exportLoading = true;
		},

		[HIDE_EXPORT_LOADING](state) {
			state.exportLoading = false;
		},
	},

	getters: {
		[TableGetterKeys.exportLoading]: state => state.exportLoading,
		[TableGetterKeys.tableOptions]: state => (tableCode: string) =>
			state.tableOptions[tableCode] ?? null,
	},
};

export default store;
